import { RequestStatus } from "../constants/AppConstants";
import { BehaviorSubject } from "rxjs";
import { handleErrorMessage } from "../store/ErrorStore";

export const apiCall = async (apiCall: () => Promise<void>, requestStatusSubject: BehaviorSubject<RequestStatus>, customErrorMessage?: string, onError?: (err: unknown) => void) => {
    try {
        requestStatusSubject.next('PROCESSING');
        await apiCall();
        requestStatusSubject.next('SUCCESS');

        setTimeout(() => {
            requestStatusSubject.next(null);
        }, 3000);
    }
    catch (err) {
        if (onError) {
            onError(err);
        }

        requestStatusSubject.next('ERROR');
        const errorMessage = customErrorMessage || (err instanceof Error ? err.message : String(err));
        const stackTrace = err instanceof Error ? err.stack ?? null : null;
        handleErrorMessage('dddGenericApiCallError', errorMessage, stackTrace, customErrorMessage !== undefined);

        setTimeout(() => {
            requestStatusSubject.next(null);
        }, 3000);
    }
}
